module.exports = __webpack_public_path__ + "static/img/长图设计-SVG交互长图.c098f66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/长图设计-SVG交互长图.png
// module id = /tfk
// module chunks = 1